/**
 * Gallery-linked hero: pick the matching Gallery photos, then apply the hero's own order (Gallery item ids).
 * Photos not in `gallery_order` follow in Gallery order after the ordered ones. Shared by the public Hero and the admin preview.
 */
export const orderedGallerySlides = (hero = {}, gallery = []) => {
  const limit = Math.min(hero.gallery_limit || 12, 50);
  const matching = gallery.filter((g) => g?.url && (!hero.gallery_category || g.category === hero.gallery_category));
  const order = hero.gallery_order || [];
  const rank = new Map(order.map((id, i) => [id, i]));
  const sorted = [...matching].sort((a, b) => {
    const ra = rank.has(a.id) ? rank.get(a.id) : Infinity;
    const rb = rank.has(b.id) ? rank.get(b.id) : Infinity;
    if (ra !== rb) return ra - rb;
    return matching.indexOf(a) - matching.indexOf(b);
  });
  return sorted.slice(0, limit);
};
